export function asRecord(value: unknown): Record<string, unknown> | null {
  if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
    return value as Record<string, unknown>;
  }
  return null;
}

export function readString(
  record: Record<string, unknown> | null,
  key: string
): string | undefined {
  if (record === null) {
    return undefined;
  }
  const value = record[key];
  return typeof value === 'string' ? value : undefined;
}
